import React from 'react';
import PropTypes from 'prop-types';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import scrollToComponent from 'react-scroll-to-component';
import { MapStyle } from './../constants';
import { PartnerHotels as S } from './../styles';

class Map extends React.PureComponent {
  scrollTo = (id) => {
    const hotel = document.querySelector(`#hotel-${id}`);
    scrollToComponent(hotel, { offset: -65, align: 'top' });
  }
  render() {
    const { hotels } = this.props;
    return (
      <S.Map>
        <GoogleMap {...MapStyle} style={{ position: 'relative' }}>
          { hotels.map((hotel) => (
            <Marker
              key={hotel.name}
              position={{ lat: hotel.position.lat, lng: hotel.position.lng }}
              icon={hotel.markerMobile}
              title={hotel.name}
              onClick={() => this.scrollTo(hotel.id)}
            />
          )) }
        </GoogleMap>
      </S.Map>
    );
  }
}

Map.propTypes = {
  hotels: PropTypes.array.isRequired,
  modal: PropTypes.func.isRequired,
  selectedHotel: PropTypes.func.isRequired,
};

export default withGoogleMap(Map);



// WEBPACK FOOTER //
// ./src/containers/Hotel/PartnerHotels/MapMobile.js